export enum PortalEvent {
    ADD_PATIENT = 'ADD_PATIENT',
    UPDATE_PATIENT = 'UPDATE_PATIENT',
    SIGN_IN_OR_CREATE = 'SIGN_IN_OR_CREATE',
}
